import { docReady } from '../helpers/docReady';
import '../../styles/templates/collection.scss';
import { productCollection } from '../sections/productCollection';
import { facets } from '../snippets/facets';
docReady(() => {
    // console.log('collection-template');
    productCollection();
    facets();
});
